import { render } from "./BrowseCard.vue?vue&type=template&id=22279b48&scoped=true"
import script from "./BrowseCard.vue?vue&type=script&lang=js"
export * from "./BrowseCard.vue?vue&type=script&lang=js"

import "./BrowseCard.vue?vue&type=style&index=0&id=22279b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22279b48"]])

export default __exports__